import { styled } from "styled-components";
import { theme } from "../styles/Theme";
import { css } from "styled-components";

export const Link = styled.a<{active?:boolean}>`
font-weight: 400;
font-size: 14px;
letter-spacing: 1px;
text-transform: uppercase;
padding: 10px;
position: relative;
z-index: 0;

&:hover {
    &::before {
        height: 10px;
    }
}

&::before {
    content: "";
    display: inline-block;
    /* height: 8px; */

    position: absolute;
    bottom: 5px;
    left: 0;
    right: 0;
    background-color: ${theme.colors.accent};
    z-index: -1;
    height: 0;/* Никуя не понимаю, но добавили сюда для того чтобы сработал transition так как иначе ничего не меняется при ховере */
    transition: ${theme.animations.transition};

    /* если при нажатии на ссылку(которая как кнопка) через атрибут active который в пропсах приходит то применяем такие стили */
    ${props => props.active === true && css<{active?:boolean}>`
    height: 10px;
    `}
}
`
